import React from "react";
import { CircularProgress, Container, Typography, Chip, Paper, Stack, Box, TextField, Button } from "@mui/material";
import { useForm } from "../../shared/hooks/form-hook";
import { useHttpClient } from "../../shared/hooks/http-hook";
import Input from "../../shared/components/FormElements/Input";
import { VALIDATOR_REQUIRE, VALIDATOR_EMAIL } from "../../shared/util/validators";
import { useSnackbar } from "../../shared/context/snackbar-context";
import  { useMutation } from "@tanstack/react-query";
import SendIcon from '@mui/icons-material/Send';

const SUBJECTS = [
    "General Questions",
    "Marketing Opportunities",
    "Partnerships",
    "Job Posting",
    "Issues with the Site",
    "Site Placement Requests",
    "Other",
]

const ContactUs = () => {
    const { sendRequest } = useHttpClient();
    const { showSnackbar } = useSnackbar();
    const [formState, inputHandler, setFormData] = useForm(
        {
            name: {
                value: "",
                isValid: false,
            },
            email: {
                value: "",
                isValid: false,
            },
            message: {
                value: "",
                isValid: false,
            },
            sweetHoney: {
                value: "pass",
                isValid: true,
            },
            subject: {
                value: "General Questions",
                isValid: true,
            },
        }, false
    );

    const contactUsMutation = useMutation({
        mutationKey: ["contact-us"],
        mutationFn: async ({name, email, message, subject}) => {
            return await sendRequest(
                `${process.env.REACT_APP_USERS}/contact-us`,
                "POST",
                JSON.stringify({ name, email, message, subject }),
                {
                    "Content-Type": "application/json",
                }
            );
        },
        onSuccess: (data) => {
            setFormData(
                {
                    name: {
                        value: "",
                        isValid: false,
                    },
                    email: {
                        value: "",
                        isValid: false,
                    },
                    message: {
                        value: "",
                        isValid: false,
                    },
                
                    subject: {
                        value: "General Questions",
                        isValid: true,
                    },
                }, false);
            showSnackbar({
                message: data.message,
                severity: "success",
            });
        },
        onError: (err) => {
            showSnackbar({
                message: err.message,
                severity: "error",
            });
        },
    });

    const handleSubmit = async (event) => {
        event.preventDefault();
        const { name, email, message, sweetHoney, subject } = formState.inputs;
        if(sweetHoney.value !== "pass") {
            showSnackbar({
                message: "Invalid honey. Please try again.",
                severity: "error",
            });
            return;
        }
        if(!name.isValid || !email.isValid || !message.isValid || !subject.isValid) {
            showSnackbar({
                message: "Invalid form",
                severity: "error",
            });
            return;
        }

        if(message.value.trim().length < 10 || message.value.trim().length > 1000) {
            showSnackbar({
                message: "Message must be between 10 and 1000 characters (max 100 words)",
                severity: "error",
            });
            return;
        }
        contactUsMutation.mutate({ name: name.value, email: email.value, message: message.value, subject: subject.value });
    };

    return (
        <Container maxWidth="md">
          <input
          onChange={(event) => inputHandler("sweetHoney", event.target.value, true)}
          type="text" 
          id="sweet-honey" 
          label="Sweet Honey" 
          style={{ 
            backgroundColor: 'transparent', 
            color: 'transparent', 
            border: 'none', 
            outline: 'none'
            }} />
            <h1>Contact Us</h1>
            <Stack>
                <Typography variant="subtitle2">Got a question? Let's Chat! We respond within 24 hours.</Typography>
            </Stack>
            <form onSubmit={handleSubmit}>
            <Input
                element="select"
                id="subject"
               // label="Subject"
                fieldLabel="Subject"
                initialValue="General Questions"
                options={SUBJECTS}
                onInput={inputHandler}
                validators={[VALIDATOR_REQUIRE()]}
                value={formState.inputs.subject.value}
                isValid={formState.inputs.subject.isValid}
                sx={{ background: (theme) => theme.palette.background.paper }}
                />

                <Input
                element="input"
                type="text"
                id="name"
                
                fieldLabel="Name"
                validators={[VALIDATOR_REQUIRE()]}
                value={formState.inputs.name.value}
                isValid={formState.inputs.name.isValid}
                onInput={inputHandler}
                />
               
            <Input
                element="input"
                type="email"
                id="email"
                
                fieldLabel="Email"
                validators={[VALIDATOR_EMAIL()]}
                onInput={inputHandler}
                value={formState.inputs.email.value}
                isValid={formState.inputs.email.isValid}
            />
            <TextField
            sx={{ background: (theme) => theme.palette.background.paper }}
            multiline
            fullWidth
            rows={5}
            id="message"
            label="Message"
            helperText="Please enter a message between 10 and 1000 characters"
            onChange={(event) => inputHandler("message", event.target.value, event.target.value.trim().length > 10 && event.target.value.trim().length < 1000)}
            value={formState.inputs.message.value}
            
            />
            <Button sx={{ mt: 2 }} type="submit" endIcon={contactUsMutation.isLoading ? <CircularProgress size={20} /> : <SendIcon />}>Submit</Button>
            </form>
        </Container >
    );
};

export default ContactUs;